export const CONTAINER_SELECTOR = '.ws-container';
export const CONTAINER_WIDTH_CLASS = 'cw';
export const CONTAINER_WIDTH_OPTION_ID = 'container_width';

export const CONTAINER_WIDTH_PRESETS = {
  NARROW: 'narrow',
  WIDE: 'wide',
  FILL: 'fill',
  CUSTOM: 'custom',
};

export const CONTAINER_WIDTH_NARROW_PX = 1200;
export const CONTAINER_WIDTH_WIDE_PX = 1600;
export const CONTAINER_WIDTH_MIN_CUSTOM_PX = 300;
export const CONTAINER_WIDTH_MAX_CUSTOM_PX = 1600;
